import _get from "lodash/get";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import {
    API_URL_CHECK_CUSTOMER_AND_SET_ACCOUNT_ID,
    API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS,
    FORM_ID,
} from "../../../../../constants";
import { RootState } from "../../../../../models";
import { CheckCustomerAndSetPersonalDetailsRequestBody } from "../../../../../models/actionPayloads";
import { CartState, SubscriptionsState } from "../../../../../models/state";
import { post as Ajax_post } from "../../../app/Ajax";
import { actions as AUTH_ACTIONS } from "../../../authentication";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import TEXT from "../../text-consts";
import * as AT from "../actionTypes";
import * as COMBINED_SELECTORS from "../selectors/combinedSelectors";
import * as CUSTOMER_SELECTORS from "../selectors/customerInfoSelectors";
import { getFormById } from "../selectors/formSelectors";

type CheckCustomerAndSetPersonalDetailsResponse = {
    cart: CartState;
    redirectTo?: string;
    subscriptions: SubscriptionsState;
};

export const setValue = (field: string, value?: string | string[] | boolean) => ({
    type: AT.CHECKOUT_SET_VALUE,
    field,
    value,
});

export const resetBankId = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) => {
    dispatch(AUTH_ACTIONS.bankIdReset());
};

export const setPersonalDetails = (): ThunkAction<void, RootState, unknown, AnyAction> => {
    return (dispatch, getState) => {
        const { values } = getFormById(getState(), FORM_ID.PERSONAL_DETAILS);
        const { values: contactInfoValues } = getFormById(getState(), FORM_ID.CONTACT_INFO);
        const isHardwareOnly = COMBINED_SELECTORS.isHardwareOnly(getState());
        const isHwOnlyButRequireBankid = COMBINED_SELECTORS.isHwOnlyButRequireBankid(getState());
        const isCampaignToggled = CUSTOMER_SELECTORS.isCampaignToggled(getState());
        const campaignId = COMBINED_SELECTORS.getCampaignId();
        let personalData = null;

        if (isHardwareOnly && !isHwOnlyButRequireBankid) {
            personalData = {
                firstName: values.hardwareOnly[VALIDATION_FIELD.FIRST_NAME],
                lastName: values.hardwareOnly[VALIDATION_FIELD.LAST_NAME],
                postcode: values.hardwareOnly[VALIDATION_FIELD.POSTCODE],
                street: values.hardwareOnly[VALIDATION_FIELD.STREET],
                city: values.hardwareOnly[VALIDATION_FIELD.CITY],
            };
        }

        let email = null;
        let phone = null;

        if (isHardwareOnly && !isHwOnlyButRequireBankid) {
            email = _get(values, `hardwareOnly.${VALIDATION_FIELD.EMAIL}`, "");
            phone = _get(values, `hardwareOnly.${VALIDATION_FIELD.PHONE}`, "").replace(/\s/g, "");
        } else {
            email = _get(contactInfoValues, `contactInfo.${VALIDATION_FIELD.CONTACT_EMAIL}`, "");
            phone = _get(contactInfoValues, `contactInfo.${VALIDATION_FIELD.CONTACT_PHONE}`, "").replace(/\s/g, "");
        }

        const personalDetailsContainer: CheckCustomerAndSetPersonalDetailsRequestBody = {
            // @ts-expect-error: personalData contains any-values
            personalData,
            campaignId: isCampaignToggled ? campaignId : null,
            extraPersonalData: {
                email,
                phone,
            },
        };

        const response = Ajax_post<CheckCustomerAndSetPersonalDetailsResponse>(
            {
                url: API_URL_CHECK_CUSTOMER_AND_SET_PERSONAL_DETAILS,
                data: personalDetailsContainer,
            },
            dispatch,
        ).then((responseData) => {
            if (responseData?.redirectTo && typeof responseData.redirectTo === "string") {
                window.location.href = responseData.redirectTo;
                return { success: false };
            }
            return {
                success: true,
                cart: responseData.cart,
                subscriptions: responseData.subscriptions,
            };
        });

        return dispatch({
            type: AT.CHECKOUT_SET_PERSONAL_DETAILS,
            payload: response,
            meta: {
                flashOnError: {
                    defaultErrorMessage: TEXT.ERROR.ORDER_SUBMIT,
                },
            },
        });
    };
};

export const checkBan =
    (
        accountId: string,
    ): ThunkAction<
        Promise<{ cart: CartState; subscriptions: SubscriptionsState; success: boolean }>,
        RootState,
        unknown,
        AnyAction
    > =>
    (dispatch) => {
        const response = Ajax_post<{ cart: CartState; subscriptions: SubscriptionsState }>(
            {
                url: API_URL_CHECK_CUSTOMER_AND_SET_ACCOUNT_ID,
                data: { accountId },
            },
            dispatch,
        ).then(({ cart, subscriptions }) => ({
            success: true,
            cart,
            subscriptions,
        }));

        dispatch({
            type: AT.CHECKOUT_SET_SELECTED_ACCOUNT,
            payload: response,
        });

        return response;
    };
